export const schedulePages = {
  slot: 'slot',
  event: 'event',
  sport: 'sport',
  sportByEvents: 'sport-by-events',
  sportByCorp: 'sport-by-corp',

  isByEvents: (value: string) => value === schedulePages.sportByEvents,
  isByCorp: (value: string) => value === schedulePages.sportByCorp,
};